import styled, { css } from "styled-components";
import { ADMIN_LK } from "@constants";

export const RootContainer = styled.div`
  height: calc(100vh - 70px);
  overflow: hidden;
  position: relative;
  background: #F7F7F7;
`;

export const EmptyText = styled.div`
  height: ${props => `calc(100vh - 181px - ${props.optHeight}px)`};
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  color: #808080;
`;

export const Container = styled.div.attrs({
  id: "scrollableDiv",
})`
  width: 100%;
  height: ${props => `calc(100vh - 181px - ${props.optHeight}px)`};
  padding: 0 0 12px 0;
  overflow: auto;
  display: flex;
  flex-direction: column-reverse;
`;

export const MessageText = styled.div`
padding: 12px;
border-radius: ${props => props.sender === ADMIN_LK ? '16px 16px 16px 0' : '16px 16px 0px 16px'};
background: ${props => props.sender === ADMIN_LK ? '#FFFFFF' : '#006400'};
max-width: 250px;
white-space: pre-wrap;
word-break: break-word;
width: fit-content;

font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #1C1C1C;

a {
    color: #1677ff !important;

    :active {
      color: #1677ff !important;
    }
  }
`;

export const DateText = styled.div`
  margin-bottom: 6px;
  margin-top: 16px;
  font-size: 12px;
  font-weight: 400;
  color: #616161;
  text-align: center;
`;

export const SpinWrapper = styled.div`
  padding: 14px;
  text-align: center;
`;

const styles = css`
  height: ${props => `calc(100vh - 181px - ${props.optHeight}px)`};
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const InitialMessage = styled.div`
  ${(props) => props.size === "large" && styles}

  >div {
    margin-top: 16px;
    margin-left: 16px;
    padding: 12px;
    border-radius: 16px 16px 16px 0px;
    background: #FFFFFF;
    max-width: 250px;
    white-space: pre-wrap;
    word-break: break-word;
    width: fit-content;
    text-align: left;
    align-self: flex-start;
    position: relative;

    @media screen and (max-width: 480px) {
      width: fit-content;
      max-width: 60vw !important;
    }
  }

  ${MessageText} {
    line-height: 1.5;
  }
`;

export const NameText = styled.span`
padding-right: 5px;
font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
color: #006400;
`;

export const TimeText = styled.span`
font-size: 12px;
font-style: normal;
font-weight: 400;
color: #4F4F4F;
line-height: 1.5;
`;

export const TimeWrapper = styled.div`
display: flex;
align-items: center;
`;

export const MessageItem = styled.div`
margin: 0 16px 16px 16px;
text-align: ${props => props.sender === ADMIN_LK ? 'left' : 'right'};
align-self: ${props => props.sender === ADMIN_LK ? 'flex-start' : 'flex-end'};
position: relative;
display: flex;
flex-direction: column;

${MessageText} {
  color: ${props => props.sender === ADMIN_LK ? '#1E1E1E' : '#fff'};
}

${TimeWrapper} {
justify-content: ${props => props.sender === ADMIN_LK ? 'flex-start' : 'flex-end'};
}

.anticon {
  color: #E1A59C;
}

@media screen and (max-width: 480px) {
  width: fit-content;
  max-width: 60vw !important;
}
`;